/* eslint-disable no-param-reassign */
export default {
    /**
     * @override
     */
    SET_FULLSCREEN(state, isFullScreen) {
        state.fullscreen = isFullScreen;
    }
};
